const getCustomizableProductUrl = (
  customizationUrl: string,
  itemNumber: string,
) => {
  return (
    customizationUrl ||
    `/customized-products/${encodeURIComponent(
      itemNumber.toLowerCase().replace("/", "*"),
    )}/`
  );
};

export default getCustomizableProductUrl;
